import { render, staticRenderFns } from "./CopperCategory.vue?vue&type=template&id=69f87c18&scoped=true&"
import script from "./CopperCategory.vue?vue&type=script&lang=js&"
export * from "./CopperCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f87c18",
  null
  
)

export default component.exports